// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./InputSelect.Options.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, ContainerPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const OptionsContext = createContext(null);

function Options(_props) {
  const defaults = useContext(OptionsContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="H4aiP4pDGc"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "H4aiP4pDGc",
        scope: "Q6DcJu6jQy",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"Container_FduThV6UrM"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_Q6DcJu6jQy_FduThV6UrM"
          }
          key={"FduThV6UrM"}
          addSpacing={false}
          element={getStyle("FduThV6UrM", "htmlElement")}
        >
          {
            <ContainerPrimitive
              key={"MMPodXBfpt"}
              id={"Slot_MMPodXBfpt"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_Q6DcJu6jQy_MMPodXBfpt"
              }
              addSpacing={true}
            >
              {props.children}
            </ContainerPrimitive>
          }
        </ContainerPrimitive>
      )}
    </RootPrimitive>
  );
}

Options.__variants = [];

export default Options;
